import { createContext } from 'react';

type ContextProps = {
  /**
   * pathsManifest object
   */
  paths: Record<any, any>;
  /**
   * returns true if impersonatorEmail, impersonatorUserToken exists and isPostingPathAdmin is true
   */
  isImpersonator: boolean;
  /**
   * returns true if mobileDetect.mobile() is true, regardless of screenwidth
   */
  isMobileDevice: boolean;
  /**
   * returns true if user is an admin
   */
  isPostingPathAdmin: boolean;
  /**
   * returns true if MessageList query has an error
   */
  hasMessageListError: boolean | null;
  /**
   * sets the message list error state
   */
  setHasMessageListError: (isError: boolean | null) => void;
};

/**
 * AppContext stores app specific data, not specific to the inbox page.
 */
export const AppContext = createContext<ContextProps>({} as ContextProps);
export const AppContextProvider = AppContext.Provider;
